import i18next from 'i18next';
import { FC, useEffect } from 'react';
import { useSendAttributionTouchMutation } from 'rtkQuery/sharespro/queries/attribution';
import { createAttributionTouch } from 'utils/attribution';

let attributionStarted = false;

const AttributionTracker: FC = () => {
  const [sendTouch] = useSendAttributionTouchMutation();

  useEffect(() => {
    if (attributionStarted) return;
    attributionStarted = true;
    try {
      void sendTouch(createAttributionTouch(i18next.language)).catch(() => undefined);
    } catch {
      // Analytics failures are intentionally invisible to the user.
    }
  }, [sendTouch]);

  return null;
};

export default AttributionTracker;
